import { icons } from 'assets/icons';
import useDevice from 'hooks/useDevice';
import { useState } from 'react';

import IconButton from 'components/Button/IconButton';
import { useAssetListStore, useLayoutStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import { Box, Horizontal, StretchSpacer, Vertical } from 'gls';
import { style } from 'typestyle';
import { DownloadAssets } from './Download/DownloadAssets';
import DownloadAssetLogs from './Download/DownloadAssetLogs';
import HeaderDefault, { PageHeaderStyle } from 'components/Header/HeaderDefault';
import { observer } from 'mobx-react';
import { headerStyle } from 'styling/App.style';
import CategorySearchSelect from 'components/inputs/Select/CategorySearchSelect/CategorySearchSelect';
import { PageError } from 'components/Header/components/PageError';

const HeaderAssetSearch = observer(() => {
  const { isMobileDevice } = useDevice();
  const {
    assetList,
    error,
    setSearchTerm,
    setSearchCategory,
    loadAssets,
    searchCategoriesList
  } = useAssetListStore();
  const [showSearch, setShowSearch] = useState(false);
  const [showCloseSearch, setShowCloseSearch] = useState(true);
  const { canReportAssets } = useUserRolePermissionStore()
  const { pageTitle, pageSubTitle } = useLayoutStore()

  const onSearch = (search: string, category: string) => {
    setSearchTerm(search)
    setSearchCategory(category)
    return loadAssets(true)
  }

  if (isMobileDevice) {
    return (
      <Vertical spacing={5} className={PageHeaderStyle(isMobileDevice)} >
        {showSearch
          ? <Box className={searchStyle}>
            <CategorySearchSelect
              onSearch={onSearch}
              onInputchange={(value) => setShowCloseSearch(value === "")}
              placeholder='Search for assets'
              categoryListTitle="REFINE MY SEARCH"
              searchCategoriesList={searchCategoriesList}
            />
            {showCloseSearch && (
              <IconButton
                ariaLabel="Close Search"
                className="close-search"
                icon={<icons.CloseIcon aria-label='Close Search' width="15px" height="15px" />}
                onClick={() => setShowSearch(false)}
              />
            )}
          </Box>

          : <Horizontal>
            <span className='HeaderTitle'>{pageTitle}</span>
            <StretchSpacer />
            <IconButton ariaLabel="Open Search"
              icon={<icons.SearchIcon aria-label='Open Search' />} onClick={() => setShowSearch(true)} />
          </Horizontal>
        }
        {pageSubTitle !== "" && <span className='subHeaderTitle'>{pageSubTitle}</span>}
        <PageError error={error} />
      </Vertical >
    );
  }

  return (
    <>
      <HeaderDefault />
      <Horizontal className={headerStyle} spacing="0">
        <CategorySearchSelect
          onSearch={onSearch}
          placeholder='Search for assets'
          searchCategoriesList={searchCategoriesList}
          categoryListTitle="REFINE MY SEARCH"
        />
        <StretchSpacer />
        <DownloadAssets disabled={assetList.length === 0} />
        {canReportAssets && (<DownloadAssetLogs disabled={false} />)}
      </Horizontal>
    </>
  );
})

export default HeaderAssetSearch;

const searchStyle = style({
  $nest: {
    ".close-search": {
      position: 'absolute',

      right: '12px',
      top: '15px'
    }
  }
})